export default {
    '010': 'ofline',
    '020': 'sem atualização via socket',
    '030': '',

    //schedule
    '300': 'Não há horário definido para esse profissional',
    '310': 'Não há procedimento definido para esse profissional',
};